/* Getting the cart ready for one of this page's offers (owner, 2026-10-01).
   The buttons used to EMPTY the cart first. That threw away anything else the shopper had
   picked — wipes, pads, bags — and cost a round trip on every tap. Now:
     - the cart is read once in the background as the page loads; if it was empty and this
       page has not written to it since, there is nothing to prepare (most ad visitors);
     - otherwise the cart is read fresh and only the lines that would clash are removed:
       a trial box (a second trial is refused, "one trial per customer") and any of this
       page's own underwear variants (no duplicate packs, e.g. after a retry).
   Other products stay. Checked on the live store 2026-10-01: the 40% and 20% codes
   discount only the underwear lines, and a trial checks out alongside other products.
   Exposed on window so skip-trial-acq.js uses the same rule. Falls back to an empty cart
   if anything about the read fails, which is the old, safe behaviour. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var getCart = function () {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); });
  };
  var post = function (path, body) {
    return fetch(root + path, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(path + ' ' + r.status); return r.json(); });
  };
  var ids = null;
  var offerIds = function () {
    if (ids) return ids;
    ids = {};
    ['trial-config', 'skiptrial-config', 'threepack-config'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      var cfg;
      try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
      var v = cfg && cfg.variants;
      if (!v) return;
      (Array.isArray(v) ? v : Object.keys(v).map(function (k) { return v[k]; })).forEach(function (x) {
        var id2 = x && typeof x === 'object' ? x.id : x;
        if (id2) ids[String(id2)] = true;
      });
    });
    return ids;
  };
  var clashes = function (item) {
    return offerIds()[String(item.variant_id)] ||
      /^trial\b/i.test(item.product_title || '') || /(^|-)trial(-|$)/.test(item.handle || '');
  };
  var dirty = false;
  var snapshot = null;
  var start = function () { if (!snapshot) snapshot = getCart().catch(function () { return null; }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.lpPrepCart = function () {
    start();
    var wasDirty = dirty;
    dirty = true;
    return snapshot
      .then(function (snap) {
        if (!wasDirty && snap && Number(snap.item_count) === 0) return null;
        return getCart();
      })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var updates = {};
        var n = 0;
        cart.items.forEach(function (item) { if (clashes(item)) { updates[item.key] = 0; n++; } });
        if (n) return post('cart/update.js', { updates: updates });
      })
      .catch(function () { return post('cart/clear.js', {}); });
  };
})();

/* Because — trial landing pages. Vanilla JS, no dependencies.
   Shared by sections/trial-lp.liquid ($9.99 underwear) and sections/pads-trial-lp.liquid
   ($6.99 pads). Everything here is driven off the DOM and #trial-config, so the two pages
   differ only in their markup and their config — never in this file. The pads page has no
   size step and no 3-pack block; each feature below simply no-ops when its hooks are absent. */
(function () {
  // The scroll/release behaviour for this page's own .site-header lived here. That
  // header is gone — layout/landing.liquid renders the shared spark-header, whose
  // own scroll handling comes from spark.js.

  // Who it's for — carried IN, and kept.
  //
  // Step 1 of the fit test shipped with Women checked and nothing that could ever
  // change it, so a man arrived on a women's page every time: from the men's
  // collection, from a men's PDP, and again on their own second visit. Reloading the
  // page — which the header's own "Start my trial" CTA does — threw the answer away
  // too. A shopper who picks Men, clicks through and lands back on women's products
  // has no reason to believe the rest of the flow will hold either — the shopper who
  // hit this in the SimGym run called the experience unreliable and left without
  // finishing the trial.
  //
  // Two inputs, most specific first:
  //   ?for=men (or ?gender=Men)  a gendered surface sending the shopper here —
  //                              snippets/spark-trial-cta.liquid appends it from the
  //                              men's collections and men's PDPs.
  //   sessionStorage             what they last chose on a trial page, so a reload,
  //                              a back-navigation or the other trial page keeps it.
  //
  // Nothing here GRANTS anything: it moves a radio the shopper could move themselves,
  // and only ever to a value this page's own markup offers. An unknown value is
  // ignored rather than guessed at. Runs before every other block in this file so the
  // absorbency gating, the image swap and the retail links all initialise from the
  // restored answer instead of repainting after it.
  (function () {
    var form = document.querySelector('.selector');
    if (!form) return;
    var radios = form.querySelectorAll('input[name="gender"]');
    if (!radios.length) return;

    var KEY = 'bmTrialWho';
    var ALIASES = { men: 'men', man: 'men', male: 'men', women: 'women', woman: 'women', female: 'women' };

    // Map any spelling onto a radio that actually exists on this page, so the values
    // stay the page's ("Women"/"Men") and a link written as ?for=male still lands.
    var resolve = function (value) {
      if (!value) return null;
      var want = ALIASES[String(value).trim().toLowerCase()] || String(value).trim().toLowerCase();
      for (var i = 0; i < radios.length; i++) {
        var v = radios[i].value.toLowerCase();
        if (v === want || (ALIASES[v] && ALIASES[v] === want)) return radios[i];
      }
      return null;
    };

    var read = function (name) {
      try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
    };
    var stored = function () {
      try { return window.sessionStorage.getItem(KEY); } catch (e) { return null; }
    };

    var pick = resolve(read('for') || read('gender')) || resolve(stored());
    if (pick && !pick.checked) pick.checked = true;

    form.addEventListener('change', function (e) {
      if (e.target.name !== 'gender') return;
      try { window.sessionStorage.setItem(KEY, e.target.value); } catch (err) {}
    });
  })();

  // Reviews carousel — prev/next arrows, with end-state disabling
  (function () {
    var track = document.getElementById('reviewsTrack');
    if (!track) return;
    var prev = document.querySelector('.rev-arrow[data-rev=prev]');
    var next = document.querySelector('.rev-arrow[data-rev=next]');
    var step = function () { var c = track.querySelector('.review-card'); return c ? c.getBoundingClientRect().width + 16 : 320; };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    // Advance one card per arrow via instant scrollLeft. With scroll-snap it lands cleanly on a card,
    // and it works everywhere — including background/hidden tabs where animated scrolling is throttled.
    var slideBy = function (dir) {
      var max = track.scrollWidth - track.clientWidth;
      track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + dir * step()));
      update();
    };
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () { slideBy(btn.dataset.rev === 'next' ? 1 : -1); });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  // Selector product image: toggle pack <-> cross-section (canvas AND modal), swap both to the chosen
  // absorbency, and open a larger view in a modal. URLs come from data-pack/data-cutaway on the radios.
  (function () {
    var frame = document.querySelector('.selector-media__frame.prod-toggle');
    var form = document.querySelector('.selector');
    if (!frame || !form) return;
    var pack = document.getElementById('selectorProduct');
    var cutaway = document.getElementById('selectorCutaway');
    if (!pack || !cutaway) return;
    var dlg = document.getElementById('imgZoom');
    var zImg = dlg ? dlg.querySelector('.zoom-modal__img') : null;

    // TWO MODES, chosen per absorbency by whether its radio carries data-gallery:
    //
    //   gallery  the pads LP — the radio ships the product's FULL image list as JSON, so the
    //            arrows walk all 7-9 shots and `pack` is the single element they paint into.
    //   flip     the underwear LP — two hardcoded theme assets, pack <-> cross-section, the
    //            original behaviour. Also the fallback if the JSON is absent or unparseable,
    //            so a bad gallery degrades to two working images rather than a blank frame.
    var gallery = null;                                   // array of {src, alt}, or null in flip mode
    var idx = 0;
    var view = 'pack';

    var readGallery = function (radio) {
      if (!radio) return null;
      var raw = radio.getAttribute('data-gallery');
      if (!raw) return null;
      try {
        var g = JSON.parse(raw);
        return Array.isArray(g) && g.length ? g : null;
      } catch (err) {
        return null;                                      // malformed → flip mode
      }
    };

    // In gallery mode everything paints into `pack`, so it is always the live element.
    var activeImg = function () {
      if (gallery) return pack;
      return view === 'pack' ? pack : cutaway;
    };
    var apply = function () {
      if (gallery) {
        var shot = gallery[idx];
        if (shot) { pack.src = shot.src; pack.alt = shot.alt || pack.alt; }
        frame.setAttribute('data-view', 'pack');
        pack.hidden = false;
        cutaway.hidden = true;
      } else {
        frame.setAttribute('data-view', view);
        pack.hidden = view !== 'pack';
        cutaway.hidden = view !== 'cutaway';
      }
      if (zImg && dlg.open) { var a = activeImg(); zImg.src = a.currentSrc || a.src; zImg.alt = a.alt; }
    };

    // One arrow handler for both modes: step through the gallery, or flip the two views.
    // Direction matters now that there are more than two images, so read data-toggle.
    var step = function (dir) {
      if (gallery) idx = (idx + dir + gallery.length) % gallery.length;
      else view = view === 'pack' ? 'cutaway' : 'pack';
      apply();
    };
    var bindArrows = function (root) {
      root.querySelectorAll('.prod-toggle__arrow, .zoom-modal__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          step(btn.getAttribute('data-toggle') === 'prev' ? -1 : 1);
        });
      });
    };
    bindArrows(frame);

    // Absorbency change → adopt that level's gallery and restart at its first shot. Falls back
    // to the pack/cutaway pair when the level has no gallery.
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'abs') return;
      gallery = readGallery(e.target);
      idx = 0;
      var p = e.target.getAttribute('data-pack');
      if (p) { pack.src = p; pack.alt = e.target.getAttribute('data-alt') || pack.alt; }
      var c = e.target.getAttribute('data-cutaway');
      if (c) { cutaway.src = c; cutaway.alt = e.target.getAttribute('data-cutaway-alt') || cutaway.alt; }
      apply();
    });

    // Adopt whatever is already checked on load — the pads LP renders with Ultimate selected,
    // so without this the first arrow click would start from the flip-mode pair.
    gallery = readGallery(form.querySelector('input[name="abs"]:checked'));
    apply();

    // Magnify → open the current image larger.
    if (dlg && zImg) {
      var zoomBtn = frame.querySelector('.prod-toggle__zoom');
      if (zoomBtn) zoomBtn.addEventListener('click', function () {
        var a = activeImg(); zImg.src = a.currentSrc || a.src; zImg.alt = a.alt;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
      bindArrows(dlg);   // modal arrows walk the same list, so the canvas stays in sync behind it
      var zClose = dlg.querySelector('[data-close-zoom]');
      if (zClose) zClose.addEventListener('click', function () { dlg.close(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }
  })();

  // Protection-level gating — only used by pages whose absorbency radios carry data-for
  // (the pads LP: the four women's levels are women-only, the guards men-only). A level
  // that doesn't apply to the chosen gender is REMOVED from the row rather than disabled,
  // because a greyed-out box is one more thing to decode. If the gating hides whatever was
  // checked, the first still-visible level takes over — the form is never left with
  // nothing selected — and a change event is dispatched so the product image swap
  // downstream repaints. No data-for on the page (the underwear LP) = no-op.
  (function () {
    var form = document.querySelector('.selector');
    if (!form) return;
    var gated = form.querySelectorAll('input[name="abs"][data-for]');
    if (!gated.length) return;

    var apply = function () {
      var g = form.querySelector('input[name="gender"]:checked');
      var gender = g ? g.value : null;
      var firstVisible = null;
      var checkedHidden = false;
      gated.forEach(function (input) {
        var allowed = (input.getAttribute('data-for') || '').split(/\s+/).indexOf(gender) !== -1;
        var box = input.closest('.choice') || input;
        box.hidden = !allowed;
        if (!allowed) {
          if (input.checked) checkedHidden = true;
          input.checked = false;
        } else if (!firstVisible) {
          firstVisible = input;
        }
      });
      // Repaint only when the gating actually moved the selection, so a plain gender
      // switch that keeps the same level doesn't reload the same image.
      var needsPick = checkedHidden || !form.querySelector('input[name="abs"]:checked');
      if (needsPick && firstVisible) {
        firstVisible.checked = true;
        firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    form.addEventListener('change', function (e) {
      if (e.target.name === 'gender') apply();
    });
    apply();
  })();

  // Trial checkout — resolve selected gender|absorbency|size to the "$9.99 Trial" variant and add it
  // to the cart on the trial selling plan, then go to /checkout. Mirrors the live /pages/start-full-trial.
  (function () {
    var cfgEl = document.getElementById('trial-config');
    var form = document.querySelector('.selector');
    if (!cfgEl || !form) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.sellingPlan || !cfg.variants) return;

    // Which offer this page is running. Both values reach reporting — offerLabel lands on
    // the order as a cart attribute, source tags the analytics events — so the $9.99
    // underwear funnel and the $6.99 pads funnel stay separable. Defaults keep the
    // underwear page behaving exactly as it did before these keys existed.
    var OFFER = cfg.offerLabel || '$9.99 trial';
    var SOURCE = cfg.source || 'trial_lp';

    var val = function (name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    };

    // Variant key. Built from whichever steps the page actually has, in a fixed order, so
    // the underwear page still yields "Women|Overnight|L" while the size-less pads page
    // yields "Women|Overnight" — no empty trailing segment to strip in the config.
    var selectionKey = function () {
      return ['gender', 'abs', 'size'].map(val).filter(Boolean).join('|');
    };

    // ── Shared by BOTH offers (the $9.99 trial and the 3-pack test below) ──────────

    // Consent gate (CIPA), the same one assets/store-locator.js uses: if the visitor has
    // explicitly NOT granted analytics consent, drop the event entirely — no dataLayer
    // push either. Silence from the API (not loaded yet, no banner) counts as allowed.
    var canTrack = function () {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !(cp && typeof cp.userCanBeTracked === 'function' && !cp.userCanBeTracked());
    };

    // Size is the one answer with no default. A size-less tap doesn't disable the button
    // (no dead/greyed look) — it scrolls up to the size step and escalates the standing
    // hint to a red alert. Returns true when the tap should stop here.
    // Pads have no sizes at all: with no size input on the page there is nothing to gate
    // on, so this waves the tap straight through instead of throwing on a null element.
    var sizeInput = form.querySelector('input[name="size"]');
    var needsSize = function () {
      if (!sizeInput) return false;
      if (val('size')) return false;
      var step = sizeInput.closest('.selector__step');
      if (step) { step.classList.add('is-invalid'); step.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      var rq = document.getElementById('sizeRequired');
      if (rq) { rq.hidden = false; rq.classList.add('is-alert'); rq.textContent = 'Please choose your size to continue.'; }
      return true;
    };

    // Survey capture — the fit-test answers as CART ATTRIBUTES, so they surface on the
    // resulting order's "Additional details" in Shopify admin (human-readable alongside
    // the variant). `extra` lets a caller stamp which offer was taken. First-party order
    // data (fulfillment context), not third-party tracking, so it isn't consent-gated.
    var cartAttrs = function (extra) {
      var attrs = {
        'Fit test — Who it\'s for': val('gender') || '',
        'Fit test — Protection level': val('abs') || '',
        'Fit test — Size': val('size') || ''
      };
      // OpenAI Ads click id / browser ref, for the shoppers who arrived from a
      // ChatGPT ad. assets/oai-attribution.js already wrote these on page load;
      // folding them into THIS request is the belt-and-braces — it is the last
      // cart write before the checkout redirect, so a page-load write that
      // failed (or an __obref cookie the SDK only minted after load) still
      // lands on the order. Returns {} for everyone else, and already applies
      // its own consent check, so no extra gate is needed here.
      try {
        var oai = window.oaiAttribution && window.oaiAttribution.cartAttributes();
        for (var oaiKey in oai) {
          if (Object.prototype.hasOwnProperty.call(oai, oaiKey)) attrs[oaiKey] = oai[oaiKey];
        }
      } catch (e) {}
      // A page's own attribution keys (the clear arm sets window.clrCartBase = { _lp, _lead_offer }),
      // folded into this, the last cart write before checkout, so they land on the order even when
      // the page's earlier write raced this one. Absent on every other page: a no-op there.
      try {
        var base = window.clrCartBase;
        for (var baseKey in base) {
          if (Object.prototype.hasOwnProperty.call(base, baseKey)) attrs[baseKey] = base[baseKey];
        }
      } catch (e) {}
      // Ad click ids (fbclid / gclid / gbraid / wbraid / msclkid / ttclid) and Meta's _fbc /
      // _fbp, as hidden cart attributes, so the order itself records which ad click it came
      // from even when a pixel never got to fire. snippets/defer-third-party.liquid keeps
      // them and returns {} unless the visitor's consent allows tracking right now.
      try {
        var ad = window.bcmAdIds && window.bcmAdIds.cartAttributes();
        for (var adKey in ad) {
          if (Object.prototype.hasOwnProperty.call(ad, adKey)) attrs[adKey] = ad[adKey];
        }
      } catch (e) {}
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) attrs[k] = extra[k];
      }
      return attrs;
    };

    // Marketing event — record the completed fit test in Klaviyo and GA4 even when the
    // shopper doesn't buy. The Klaviyo onsite SDK is loaded site-wide un-deferred (company
    // id injected by the app embed), so window.klaviyo.push is available here. GA4 runs
    // through the Littledata + Analyzify app embeds and window.gtag is the ONLY path that
    // reaches the property — there is no GTM container on the storefront, so a dataLayer
    // push alone goes nowhere. Same event name as the site quiz (assets/spark.js) so both
    // surfaces report as one funnel step; `source` tells them apart. Fire-and-forget:
    // never awaited, always called BEFORE the cart writes so the SDKs have a flush window.
    var trackFitTest = function (props) {
      trackAdFitTest(props);
      if (!canTrack()) return;
      try { window.klaviyo.push(['track', 'Fit Test Completed', props]); } catch (e) {}
      try {
        if (typeof window.gtag === 'function') window.gtag('event', 'fit_test_completed', props);
      } catch (e) {}
    };

    // Checkout-intent event, one per offer. Deliberately NOT named begin_checkout:
    // Littledata already fires that on the real checkout with items/value, and reusing the
    // name here would double-count the step. gtag's GA4 transport is sendBeacon, so it
    // survives the redirect. The dataLayer push is kept purely for a future listener.
    var trackIntent = function (name, props) {
      if (!canTrack()) return;
      try {
        if (typeof window.gtag === 'function') window.gtag('event', name, props);
      } catch (e) {}
      var payload = { event: name };
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k)) payload[k] = props[k];
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    };

    // Ad-platform signal for the fit test (2026-10-01 ad-signal audit).
    //
    // Until now the ad platforms saw nothing between the trial page's PageView and the
    // AddToCart that Shopify's cart events send when the CTA's cart/add.js succeeds — the
    // fit test, the page's real conversion step, went to GA4 and Klaviyo only. This sends
    // it to Meta as the visitor finishes it: a standard ViewContent for the matched trial
    // pack (a standard event Meta's delivery models and audiences use) plus a custom
    // FitTestCompleted, each with its own event_id. It also publishes fit_test_completed
    // on Shopify's customer-events bus, where a custom pixel can forward it to the other
    // platforms (their Shopify apps only listen for Shopify's standard events).
    //
    // What it deliberately does NOT send: AddToCart / InitiateCheckout. Shopify already
    // sends both for every trial and 3-pack tap (cart/add.js -> product_added_to_cart ->
    // Meta, Google Ads, TikTok, Bing, Reddit, AppLovin; the checkout -> checkout_started)
    // and Littledata sends them server-side, so a theme copy would double-count them.
    // Nothing else sends a ViewContent on this page (Shopify's product_viewed is PDP-only).
    //
    // Consent: only when Shopify's Privacy API says this visitor can be tracked (true, not
    // merely "not refused") — in a consent region fbevents.js is not even loaded before
    // that (snippets/defer-third-party.liquid). Once per page view.
    var adFitSent = false;
    var newEventId = function (prefix) {
      try { if (window.crypto && typeof window.crypto.randomUUID === 'function') return prefix + '-' + window.crypto.randomUUID(); } catch (e) {}
      return prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    };
    var adTrackingAllowed = function () {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      try { return !!(cp && typeof cp.userCanBeTracked === 'function' && cp.userCanBeTracked()); } catch (e) { return false; }
    };
    var offerPrice = (function () {
      var m = String(OFFER).match(/\$(\d+(?:\.\d+)?)/);
      return m ? Number(m[1]) : 0;
    })();
    var trackAdFitTest = function (props) {
      if (adFitSent || !props || !props.trial_variant_id) return;
      if (!adTrackingAllowed()) return;
      adFitSent = true;
      var id = newEventId('fit');
      var data = {
        content_ids: [String(props.trial_variant_id)],
        content_type: 'product',
        content_name: OFFER + ' | ' + (props.trial_selection || ''),
        content_category: props.source || SOURCE,
        value: offerPrice,
        currency: 'USD'
      };
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'ViewContent', data, { eventID: id });
          window.fbq('trackCustom', 'FitTestCompleted', data, { eventID: id + '-ftc' });
        }
      } catch (e) {}
      try {
        var an = window.Shopify && window.Shopify.analytics;
        if (an && typeof an.publish === 'function') {
          an.publish('fit_test_completed', {
            event_id: id,
            trial_variant_id: String(props.trial_variant_id),
            trial_selection: props.trial_selection || '',
            source: props.source || SOURCE,
            value: offerPrice,
            currency: 'USD'
          });
        }
      } catch (e) {}
    };

    // Back button — a browser that restores this page from the bfcache brings the DOM back
    // exactly as it was left: the CTA still disabled, still spinning, still reading "Starting
    // your trial…". The `if (btn.disabled) return` guard then swallows every further tap, so a
    // shopper who reaches checkout, changes their mind and hits Back finds a dead button and no
    // way to restart. Nothing is in flight after a restore — the redirect either happened or was
    // abandoned — so put the CTA back to its shipped state. `innerHTML`, not textContent: the
    // click wrote over the button's `.btn__sub` sub-label, so only the captured markup restores
    // it. Also fires on the initial load, where it is a no-op.
    var resetOnRestore = function (btn, html, after) {
      window.addEventListener('pageshow', function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.innerHTML = html;
        if (after) after();
      });
    };

    // Cart writes go over the Ajax API. They used to be a chain of browser redirects
    // (/cart/clear?return_to=/cart/add?...&return_to=/checkout), which works right up
    // until the server REFUSES a line — and the checkout-validation function refuses the
    // trial for anyone who has ordered in the past year. A redirect has nowhere to put a
    // rejection, so Shopify answered with its own bare "Something went wrong" page: the
    // message printed twice, no branding, and "Return to the previous page" as the only
    // way out. For this audience that is a dead end. The same rejection over Ajax is a
    // 422 with the reason in it, which we can show on this page next to the button.
    //
    // No eligibility rule lives in this file. The server decides; this only reports what
    // it said, and offers a way onward.
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var postJson = function (path, body) {
      return fetch(cartRoot + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r.ok) return r.json();
        // Carry the status out with the body. Whether the server REFUSED (422, with its
        // reason) or merely FAILED (429, 5xx, a bot challenge served as HTML) is the
        // difference between two completely different things to say, and without the
        // status the caller cannot tell them apart.
        return r.json().then(
          function (e) { e = e || {}; e.status = r.status; throw e; },
          function () { var e = new Error(path + ' ' + r.status); e.status = r.status; throw e; }
        );
      });
    };

    // Did the server refuse this line, or did the request just not get through?
    //
    // A refusal is a 422 from the Ajax Cart API carrying the validation function's own
    // words. Everything else — 429 (Shopify's "Verifying your connection" bot challenge
    // is served with that status), a 5xx, a dropped connection — means we were told
    // nothing. Reporting nothing as a refusal tells an eligible first-time customer the
    // trial isn't theirs and walks them to the full price instead, which is the single
    // most expensive mistake this page can make.
    var isRefusal = function (err) {
      return Boolean(err) && err.status === 422 && Boolean(err.description || err.message);
    };

    // Show the server's own words for WHY, and our own link for WHAT NEXT. Using the
    // returned message rather than a copy of it keeps one source of truth: the same
    // panel reports the trial-eligibility function and the separate one-trial-per-cart
    // rule correctly, without this file knowing either exists.
    var showTrialError = function (err) {
      // The site-wide trial guard may already have shown its toast for this same refusal;
      // the inline box below says it in context, so drop the toast and say it once.
      var guardToast = document.querySelector('[data-spark-trial-guard-notice]');
      if (guardToast && guardToast.parentNode) guardToast.parentNode.removeChild(guardToast);
      var box = document.getElementById('trialError');
      if (!box) return;
      var reason = (err && (err.description || err.message)) || '';
      // Shopify sometimes returns "<message>: <message>" — keep one copy.
      var half = reason.split(': ')[0];
      if (half && reason.indexOf(half + ': ' + half) === 0) reason = half;
      box.querySelector('[data-trial-error-text]').textContent =
        reason || 'Sorry — we could not start this trial. Please try again.';

      // Point at the pack they actually chose, not a generic collection. They have just
      // told us gender and protection level, so sending them anywhere else makes them
      // pick twice. Falls back to the shop-all link already in the markup.
      var link = box.querySelector('.trial-error__link');
      var handles = cfg.retailHandles || {};
      var handle = handles[[val('gender'), val('abs')].join('|')];
      if (link) {
        link.hidden = false;
        if (handle) {
          link.href = cartRoot + 'products/' + handle;
          link.textContent = 'See the full pack';
        }
      }

      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    // We could not get an answer. Say so, and say nothing else: no reason (we don't have
    // one), and above all no offer of the full-price pack, because for all we know this
    // shopper is entitled to the trial and simply hit a bad moment. Tapping again is the
    // whole remedy, and the button is already back.
    var showTrialFailure = function () {
      // The site-wide trial guard may already have shown its toast for this same refusal;
      // the inline box below says it in context, so drop the toast and say it once.
      var guardToast = document.querySelector('[data-spark-trial-guard-notice]');
      if (guardToast && guardToast.parentNode) guardToast.parentNode.removeChild(guardToast);
      var box = document.getElementById('trialError');
      if (!box) return;
      box.querySelector('[data-trial-error-text]').textContent =
        'Sorry — we could not start your trial just then. Please tap the button again.';
      var link = box.querySelector('.trial-error__link');
      if (link) link.hidden = true;
      box.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    form.querySelectorAll('.trial-cta').forEach(function (btn) {
      var ctaHtml = btn.innerHTML;
      resetOnRestore(btn, ctaHtml);

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (needsSize()) return;
        var key = selectionKey();
        var variantId = cfg.variants[key];
        if (!variantId) { console.warn('No trial variant mapped for', key); return; }

        // Analytics: mirror the site's checkout funnel so paid traffic attributes during the live test.
        trackIntent('trial_begin_checkout', { trial_variant_id: variantId, trial_selection: key, source: SOURCE });

        var errBox = document.getElementById('trialError');
        if (errBox) errBox.hidden = true;

        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.textContent = 'Starting your trial…';

        // Where a tap goes after this. Only ~60% of taps reach a Shopify checkout start
        // (Sep 2026, GA4 ⋈ Shopify) and nothing else here was recorded, so the other 40%
        // could be a refusal, a failed request, a shopper who gave up on the spinner, or a
        // redirect whose checkout never loaded. Exactly one outcome event fires per tap:
        //   trial_redirect        — we sent them to /checkout (ms = time on the spinner)
        //   trial_add_refused     — the server said no (422, its reason attached)
        //   trial_add_failed      — the server said nothing usable (429, 5xx, network)
        //   trial_wait_abandoned  — the page went away before any of the above (stage = the
        //                           cart write in flight when they left)
        // Same transport as trial_begin_checkout: gtag beacon, which survives the unload.
        var tapAt = Date.now();
        var stage = 'clear';
        var outcome = null;
        var report = function (name, props) {
          if (outcome) return;
          outcome = name;
          props = props || {};
          props.ms = Date.now() - tapAt;
          props.trial_selection = key;
          props.source = SOURCE;
          trackIntent(name, props);
        };
        window.addEventListener('pagehide', function () {
          report('trial_wait_abandoned', { stage: stage });
        }, { once: true });

        // Survey capture — the fit-test answers as cart attributes. /cart/clear does NOT
        // remove cart attributes (Ajax Cart API), so setting them after the add still
        // carries them onto the order.
        var attrs = cartAttrs({ 'Offer': OFFER });
        // `source` names the surface so this LP's fit test can be told apart from the
        // sitewide quiz (assets/spark.js, source: 'site_quiz') without inferring it from
        // trial_selection.
        trackFitTest({
          gender: val('gender') || '',
          absorbency: val('abs') || '',
          size: val('size') || '',
          trial_variant_id: variantId,
          trial_selection: key,
          source: SOURCE
        });

        // Attributes are best-effort: fire and proceed on a hard timeout, so a slow or
        // failed write can never strand a shopper who is otherwise good to buy. The ADD
        // is not best-effort — its answer is the whole point.
        var went = false;
        var go = function () {
          if (went) return;
          went = true;
          report('trial_redirect');
          window.location.href = cartRoot + 'checkout';
        };
        // ONE best-effort write after the add: the attributes and, on the pads page, the
        // free-shipping code (see below) go together in a single cart/update.js, which takes
        // both `attributes` and `discount`. They used to be two sequential requests — and the
        // code went over GET /discount/<code>, which 302s to the homepage, so fetch() pulled
        // the whole homepage document (~338 KB, measured 2026-10-01) onto a slow phone just
        // to set a cookie, while the shopper watched "Starting your trial…". Same end state
        // (both land on the cart that becomes the checkout), one round trip, a few KB.
        var stampAndGo = function () {
          stage = cfg.shippingCode ? 'shipping' : 'attributes';
          var body = { attributes: attrs };
          if (cfg.shippingCode) body.discount = cfg.shippingCode;
          postJson('cart/update.js', body).then(go, go);
          setTimeout(go, cfg.shippingCode ? 1500 : 1200);
        };

        // FREE SHIPPING, where the page asks for it (`shippingCode` in #trial-config —
        // the pads LP sets it, the underwear LP does not and must not).
        //
        // The two trials pay for shipping in completely different ways, because they are
        // built differently. The $9.99 underwear trial sells UNLISTED trial products, and
        // those sit in the "Full Trial Orders" delivery profile whose only rate is $0.00 —
        // free by construction, nothing to apply. The $6.99 pads trial deliberately sells
        // the RETAIL pad variants on a selling plan (no twin products to maintain), and
        // retail variants live in the General profile, where a $6.99 cart falls in the
        // $3.00–$74.99 band and is quoted $7.99. So the pads page promised free shipping
        // and the checkout charged for it.
        //
        // A delivery profile cannot fix that without making every pad order ship free, so
        // the offer carries its own code instead: SUBSCRIPTION-ONLY, first-time customers
        // only, capped at the $7.99 rate, first billing cycle so renewals still pay.
        //
        // Subscription-only is what keeps it away from the page's other offer — the 3-pack
        // below is a one-time cart and cannot match it. It is NOT product-scoped, and a
        // free-shipping CODE cannot be; the accepted exposure is one $7.99 rate per new
        // customer on some other subscription cart.
        //
        // Applied in stampAndGo above, in the same cart/update.js as the attributes, with a
        // 1.5 s cap: shipping that stays $7.99 is a bad outcome, but a shopper stuck on a
        // spinner is worse.

        window.lpPrepCart()
          .then(function () {
            stage = 'add';
            return postJson('cart/add.js', {
              items: [{ id: Number(variantId), quantity: 1, selling_plan: Number(cfg.sellingPlan) }]
            });
          })
          .then(stampAndGo)
          .catch(function (err) {
            // A refusal is a normal answer here, not a crash — a returning customer taking
            // the trial again is precisely what the server is there to stop. Put the button
            // back so nothing is stuck, and say why. Anything that isn't a refusal is a
            // failure to ask, and gets the neutral message instead.
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.innerHTML = ctaHtml;
            if (isRefusal(err)) {
              report('trial_add_refused', {
                status: err.status,
                stage: stage,
                reason: String(err.description || err.message || '').slice(0, 100)
              });
              showTrialError(err);
            } else {
              report('trial_add_failed', { status: (err && err.status) || 0, stage: stage });
              showTrialFailure();
            }
          });
      });
    });

    // ── 3-pack offer: "buy 3 packs at 25% off", no subscription ───────────────────
    // The non-subscription alternative to the trial. Same fit test, different offer:
    // three packs of whatever gender / protection level / size is selected above,
    // bought once, 25% off, no selling plan.
    //
    // ROLLED OUT (was a traffic test). It used to ship hidden and reveal itself only
    // for visitors carrying ?threepack=1 or when a section checkbox was ticked; the
    // test won, so the gate — the URL parameter, the sessionStorage that remembered
    // it across a round trip to the FAQ, and the `enabled` flag — is gone and every
    // visitor sees it.
    //
    // The `hidden` attribute STAYS in the markup and this block still removes it. That
    // is not a leftover: the button is inert without this script (it has no href and
    // its checkout runs through cart.js below), so a visitor whose JS never arrives
    // should see no button rather than a dead one.
    //
    // Checkout mirrors /pages/bundle-builder's one-time path: clear -> add qty 3 with no
    // selling plan -> apply the quantity-tiered discount code -> /checkout. See the
    // #threepack-config comment in sections/trial-lp.liquid for why the variant ids are
    // pinned and where the code comes from.
    (function () {
      var box = document.getElementById('threePack');
      var tpEl = document.getElementById('threepack-config');
      if (!box || !tpEl) return;
      var tp;
      try { tp = JSON.parse(tpEl.textContent); } catch (e) { return; }
      if (!tp || !tp.variants) return;

      var QTY = Number(tp.qty) || 3;
      // 20 is the offer. NOT `Number(tp.pct) || 20` — that reads a deliberate 0 as "missing"
      // and substitutes 20, which is the opposite of what 0 means here. A returning customer
      // is served "pct": 0 precisely so the button stops promising a saving; with `||` they
      // were shown "save 20%" underneath a notice telling them they could not have it, and
      // then charged full price, because no code is sent with it. Only a genuinely absent
      // value should fall back.
      var PCT = tp.pct === undefined || tp.pct === null || tp.pct === '' ? 20 : Number(tp.pct);
      if (!(PCT >= 0)) PCT = 20;

      box.hidden = false;

      var btn = box.querySelector('.threepack-cta');
      var priceEl = box.querySelector('[data-threepack-price]');
      if (!btn) return;
      var btnHtml = btn.innerHTML;

      var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
      // Same key builder as the trial CTA, so this works on a page with no size step
      // (pads) as well as one with (underwear). An incomplete selection simply yields a
      // key the map has no entry for, which is the old "return null" behaviour.
      var chosen = function () {
        return tp.variants[selectionKey()] || null;
      };
      // Shopify discounts PER UNIT and floors each to the cent, then multiplies — not
      // percent-of-line. Verified against draftOrderCalculate on all four sizes: 3 x
      // $24.99 bills $56.25, where percent-of-line would have shown $56.23. Match it
      // exactly, so the price on the button is the price at checkout.
      var priceFor = function (v) {
        return (v.price - Math.floor(v.price * PCT / 100)) * QTY;
      };

      // Price label follows the fit test: exact once a size is picked, generic before
      // that (the button stays live so a size-less tap still prompts for the size).
      var paint = function () {
        var v = chosen();
        var out = !!(v && v.available === false);
        btn.disabled = out;
        if (!priceEl) return;
        // PCT can legitimately be 0: a signed-in returning customer is quoted full price,
        // because the discount's customer segment would refuse them and a button that
        // promises a saving the checkout takes back is the whole failure this page has
        // been fixing. At 0 the label states the price and says nothing about savings.
        if (out) priceEl.textContent = 'Sold out in this size';
        else if (v) priceEl.textContent = money(priceFor(v)) + ' one time' + (PCT > 0 ? ' · save ' + PCT + '%' : '');
        else priceEl.textContent = PCT > 0 ? 'Save ' + PCT + '% · one-time order' : 'One-time order';
      };
      form.addEventListener('change', paint);
      paint();

      // Same bfcache restore as the trial CTA. This one re-queries the price label before
      // repainting, because the click replaced the button's markup — exactly what the
      // add-to-cart failure path below does.
      resetOnRestore(btn, btnHtml, function () {
        priceEl = btn.querySelector('[data-threepack-price]');
        paint();
      });

      // THE CODE NO LONGER COMES FROM LOOP. This used to fetch Loop's bundle config on
      // every page load, take the box tier covering this quantity, and overwrite both the
      // code and the percentage from it — because Loop rotates its codes and re-cuts its
      // tiers, and a stale copy meant a button promising a discount the cart would refuse.
      //
      // That whole apparatus is gone, because its premise is: Loop's box tiers are a
      // SUBSCRIPTION offer (LPBNDL_DISCOUNT_20 is appliesOnOneTimePurchase: false), and
      // this button sells three packs ONE TIME with no selling plan. The code could not
      // apply at all — the label said "save 20%" and the checkout charged full price, which
      // is precisely the failure the live refresh was built to prevent, arriving from the
      // other direction.
      //
      // The offer now has its own code, TRIAL3PACK20, which nothing rotates: one code, one
      // percentage, and eligibility decided by a customer segment on the discount itself
      // (never ordered, or lapsed over a year — the trial's own rule). So PCT is simply the
      // section setting, and it has to be kept in step with what that discount actually
      // gives — the applyDiscount check below is what catches it if it ever isn't.

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      var postJson = function (path, body) {
        return fetch(root + path, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error(path + ' ' + r.status); });
          return r.json();
        });
      };
      // Apply a code, then CONFIRM the cart actually got discounted before moving on — an
      // expired or mis-scoped code would otherwise bill full price silently. Walks the
      // candidates until one sticks. If none does we still go to checkout rather than
      // strand the shopper: the code cookie may yet apply there, and a cart that reads
      // undiscounted is not proof the checkout will be.
      //
      // It also answers a question worth recording now that eligibility is decided by a
      // function: the cart is anonymous at this point, so an eligible-looking shopper is
      // always discounted here, and a `false` means the OFFER is misconfigured (wrong code,
      // paused discount, a product outside its scope) rather than that this shopper was
      // turned down. The verdict is written onto the order as a cart attribute below, so a
      // misconfiguration shows up in admin instead of only in lost margin.
      var applyDiscount = function (codes, i) {
        i = i || 0;
        if (i >= codes.length) return Promise.resolve(false);
        // One request: the Ajax cart applies the code and answers with the cart. The old
        // GET /discount/CODE followed a redirect to the homepage (~340 KB of HTML) and then
        // needed a second fetch of cart.js — about a second and a half of "Setting up your
        // order…" on a phone (2026-10-01).
        return postJson('cart/update.js', { discount: codes[i] })
          .then(function (cart) {
            if (cart && Number(cart.total_discount) > 0) return true;
            return applyDiscount(codes, i + 1);
          })
          .catch(function () { return applyDiscount(codes, i + 1); });
      };

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (needsSize()) return;
        var sel = selectionKey();
        var v = chosen();
        if (!v) { console.warn('No 3-pack variant mapped for', sel); return; }

        var codes = tp.code ? [tp.code] : [];

        trackIntent('threepack_begin_checkout', {
          variant_id: v.id,
          quantity: QTY,
          value: priceFor(v) / 100,
          trial_selection: sel,
          source: 'trial_lp_3pack'
        });
        trackFitTest({
          gender: val('gender') || '',
          absorbency: val('abs') || '',
          size: val('size') || '',
          trial_variant_id: v.id,
          trial_selection: sel,
          source: 'trial_lp_3pack'
        });

        btn.classList.add('is-loading');
        btn.disabled = true;
        btn.textContent = 'Setting up your order…';

        // Attributes are set LAST of the cart writes but still before the redirect, so they
        // can't be wiped by the clear. `Offer` is what tells the two arms of this test
        // apart on the order in Shopify admin — and it now records what the cart actually
        // got, not what the button hoped for. An order that reads "discount NOT applied" is
        // a broken offer someone can find and fix; the same order with "(20% off)" on it
        // reads like a normal sale at an odd price.
        window.lpPrepCart()
          .then(function () { return postJson('cart/add.js', { items: [{ id: Number(v.id), quantity: QTY }] }); })
          .then(function () { return applyDiscount(codes); })
          .then(function (applied) {
            // Three outcomes, and they are not the same thing on an order:
            //   no code at all -> a returning customer buying at full price ON PURPOSE;
            //   code applied    -> the offer worked;
            //   code refused    -> the offer is misconfigured, and someone should look.
            var state;
            if (!codes.length) state = 'full price, returning customer';
            else if (applied) state = PCT + '% off';
            else { state = 'discount NOT applied'; console.error('trial-lp: 3-pack discount did not apply', codes); }
            return postJson('cart/update.js', {
              attributes: cartAttrs({ 'Offer': QTY + '-pack, no subscription (' + state + ')' })
            });
          })
          .then(function () { window.location.href = root + 'checkout'; })
          .catch(function (err) {
            console.error('trial-lp: 3-pack add failed', err);
            btn.classList.remove('is-loading');
            btn.disabled = false;
            btn.innerHTML = btnHtml;
            priceEl = btn.querySelector('[data-threepack-price]');
            paint();
            alert('Sorry — something went wrong. Please try again.');
          });
      });
    })();

    // Size starts unselected: clear the "choose a size" prompt + un-dim the CTA once a size is picked.
    form.addEventListener('change', function (e) {
      if (e.target.name !== 'size') return;
      var step = e.target.closest('.selector__step');
      if (step) step.classList.remove('is-invalid');
      var rq = document.getElementById('sizeRequired'); if (rq) { rq.hidden = true; rq.classList.remove('is-alert'); }
      form.querySelectorAll('.trial-cta').forEach(function (b) { b.classList.remove('is-inactive'); });
    });

    // The fit test is complete the first time the shopper's own answer leaves a full
    // selection: a size picked on the underwear page (who-for and protection level start
    // pre-ticked), or any answer changed on the pads page, which has no size step. The
    // pre-ticked defaults fire no change event, so an untouched page sends nothing here;
    // the CTA tap covers that case through trackFitTest. The size finder's "Use size X"
    // ticks the radio and fires the same change event, so it counts too.
    form.addEventListener('change', function (e) {
      var name = e.target && e.target.name;
      if (name !== 'gender' && name !== 'abs' && name !== 'size') return;
      if (sizeInput && !val('size')) return;
      var key = selectionKey();
      var variantId = cfg.variants[key];
      if (!variantId) return;
      trackAdFitTest({ trial_variant_id: variantId, trial_selection: key, source: SOURCE });
    });
  })();

  // Size-guide modal — open from "View sizing chart", close via button / backdrop / Esc
  (function () {
    var dlg = document.getElementById('sizeChart');
    if (!dlg) return;
    document.querySelectorAll('.size-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      });
    });
    var closeBtn = dlg.querySelector('[data-close-sizechart]');
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  })();

  // Sticky mobile buy bar — always one tap from the offer. It slides away while the
  // hero (which has its own CTA) or the real buy module is on screen, so it never
  // doubles a visible CTA and never sits over the footer. Desktop hides it via CSS.
  (function () {
    var bar = document.getElementById('stickyCta');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.getElementById('hero');
    var selector = document.getElementById('selector');
    var visible = { hero: false, selector: false };
    var apply = function () { bar.classList.toggle('is-hidden', visible.hero || visible.selector); };
    var watch = function (el, key, opts) {
      if (!el) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { visible[key] = en.isIntersecting; });
        apply();
      }, opts).observe(el);
    };
    watch(hero, 'hero', { threshold: 0.3 });
    watch(selector, 'selector', { rootMargin: '0px 0px -40% 0px' });
    apply();
  })();

  // "Shop this pack" in the returning-customer notice points at the EXACT pack selected,
  // not a collection — someone told the offer isn't theirs should land on the thing they
  // were already looking at, not a wall of products to re-navigate. Keyed gender|absorbency
  // from #retail-urls, which both landing pages emit from their retail products.
  //
  // No-ops everywhere the notice isn't rendered (guests, first-time customers, and the
  // whole page for anyone Liquid can't resolve), and leaves the server-rendered href — the
  // default selection's product — untouched if anything is missing. The href is therefore
  // always a real product, JS or no JS; this only keeps it in step with the selection.
  (function () {
    var link = document.querySelector('.trial-known__link');
    var form = document.querySelector('.selector');
    var urlsEl = document.getElementById('retail-urls');
    if (!link || !form || !urlsEl) return;

    var urls;
    try { urls = JSON.parse(urlsEl.textContent); } catch (e) { return; }
    if (!urls || typeof urls !== 'object') return;

    var repoint = function () {
      var g = form.querySelector('input[name="gender"]:checked');
      var a = form.querySelector('input[name="abs"]:checked');
      if (!g || !a) return;
      var url = urls[g.value + '|' + a.value];
      if (url) link.setAttribute('href', url);
    };

    form.addEventListener('change', function (e) {
      if (e.target.name === 'gender' || e.target.name === 'abs') repoint();
    });
    repoint();
  })();
})();
